<div class="inputTitle" *ngIf="label">
  <span>{{label}}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<div [class.lightning]="beLight" [class.dualLine]="dualLine" class="matDiv" *ngIf="isEditable">
  <mat-form-field [class.has-errors]="errors?.length || nestedError" appearance="outline" [hidden]="!isEditable" (focusin)="expand()"
    (focusout)="focusoutfn()" [class.errorBorder]="errors?.length">


    <textarea matInput type="text" [placeholder]="placeholder" [name]="name" *ngIf="isMultiline" [(ngModel)]="data"
      [id]="name" [disabled]="disabled" [minlength]="minlength" [maxlength]="maxlength"
      [class.expand]="expanding"> </textarea>
    <input matInput type="text" [placeholder]="placeholder" [name]="name" *ngIf="!isMultiline" [(ngModel)]="data"
      [id]="name" [disabled]="disabled" [min]="minlength" [max]="maxlength" autocomplete="off" (keypress)="default($event)" #chatter>
      <i class="flaticon-search" matPrefix *ngIf="searchIcon"></i>
  </mat-form-field>
</div>

<div class="viewLable" *ngIf="!isEditable">
  <span><i class="flaticon-email" *ngIf="emailIcon"></i> <b *ngIf="tableDesc">Description:</b>
      {{getDisplay()}}</span>
</div>

<ul *ngIf="errors?.length" class="errorList" [class.errorListEnable]="errors?.length>1">
  <li *ngFor="let item of errors" class="error top-2">{{item}}</li>
</ul>